class PageForm extends HTMLElement {
  constructor() {
    super();
    let element = this;
    let config = { childList: true, subtree: true, characterData: true };
    this.onObserver(element, config);
  }

  onObserver(element, config) {
    // create an observer instance 
    let observer = new MutationObserver(function(mutations) {
      try {
        mutations.forEach(mutation => {
          if (document.querySelectorAll('.form-control').length > 3) {
            let input = document.querySelectorAll('.form-control');            
            input.forEach((element) => {
              if (element.type == 'tel') {
                let tel = element.parentElement.parentElement.parentElement;
                let html = tel.querySelector('.control-label').innerHTML;
                let text = tel.querySelector('.control-label');

                tel.classList.add('tel')
                let label = html.replace("*", "<span>*</span>");
                text.innerHTML = label; 
              }
              
              if(element.previousSibling) {
                let html = element.previousSibling.innerHTML;
                html = html.replace("*", "<span>*</span>");
                element.previousSibling.innerHTML = html;
                element.previousSibling.parentNode.insertBefore(element, element.previousSibling);
              }  
            })
            observer.disconnect();
            throw 'Break';
          }
        })
      } catch (e) {
        if (e !== 'Break') throw e
      }
    });
    observer.observe(element, config); 
  }  
}

customElements.define('custom-app-form', PageForm);
